import { apiClient } from '@shared/api/ApiClient.ts';
import { apiRoutes } from '@shared/consts/apiRoutes.ts';
import { UserProfileByIdResponse, UserProfileResponse } from '@shared/services/userProfile/service.types.ts';
import { UserId } from '@shared/types/users.ts';

export async function getUserProfileService(): Promise<UserProfileResponse | null> {
  return await apiClient.get<UserProfileResponse>(apiRoutes.getUserProfile()).then((response) => response);
}

export async function getUserProfileByIdService(id: UserId): Promise<UserProfileByIdResponse | null> {
  return await apiClient.get<UserProfileByIdResponse>(apiRoutes.getUserProfileById(id)).then((response) => response);
}
